// getEmployeesByRoles and getManagersByEmployeeRoles should be called with consts from employeeRoles.js
const buildRolesQueryString = (employeeRolesArray) => employeeRolesArray.map(x => "roles" + "=" + x).join("&");

const employeeApi = {
  getEmployeesByRoles: employeeRolesArray => `/employees/by-role?${buildRolesQueryString(employeeRolesArray)}`,
  getEmployeeDetails: internetUserId => `/employees/${internetUserId}/details`,
  getEmployeeDetailsByEmployeeId: employeeId => `/employees/${employeeId}`,
  updateEmployeeDetails: internetUserId => `/employees/${internetUserId}/details`,
  updateEmployeeDetailsByEmployeeId: employeeId => `/employees/${employeeId}`,
  getEmployeeNotes: internetUserId => `/employees/${internetUserId}/notes`,
  addEmployeeNote: internetUserId => `/employees/${internetUserId}/notes`,
  getManagersByEmployeeRoles: employeeRolesArray => `/employees/managers/by-employee-role?${buildRolesQueryString(employeeRolesArray)}`,
  searchEmployees: (searchTerm, roles = null) => {
    let result = `/employees?searchTerm=${searchTerm}`;
    if (roles !== null) {
      result += "&" + buildRolesQueryString(roles);
    }
    return result;
  },
  getOperationsManagementEmployees: (searchTerm = null, includeInactive = false) => {
    return `/employees/operations-management/search?searchTerm=${(searchTerm ? `${searchTerm}` : "")}&includeInactive=${includeInactive ? 1 : 0}`;
  }
};
export default employeeApi;